import styled from 'styled-components'
import { Slider } from 'antd'

export const MySlider = styled(Slider)`
  margin-left: 10px;
  margin-right: 10px;
  .ant-slider-handle {
    width: 16px;
    height: 16px;
    margin-top: -4px;
    border-width: 2px !important;
  }
`
